<template>
    <div class="bg-white pt-3 rounded-md">
        <div class="flex mx-4 items-center sm:flex-nowrap space-x-4">
            <slot name="leading-action" class="flex-none" />
            <div class="flex-auto flex flex-col break-words py-2">
                <h3 class="text-lg leading-6 font-normal text-gray-900">{{ title }}</h3>
                <div v-if="subtitle" class="text-xs opacity-70">{{ subtitle }}</div>
            </div>
            <slot name="action" class="flex-none" />
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    title: string;
    subtitle?: string;
}>();
</script>
